import { Controller, useFormContext } from 'react-hook-form';

import CustomRadio from './CustomRadioBox';
import React from 'react';

/**
 * React Hook Form과 연동된 Radio 컴포넌트
 * @param {Object} props
 * @param {string} props.name - 폼 필드 이름
 * @param {Array} props.options - 라디오 옵션 배열 [{value: string, label: string}]
 */
const ControlledRadioBox = ({ name, options }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CustomRadio
          value={field.value}
          onChange={field.onChange}
          options={options}
          size="small"
          style={{ radio: { marginRight: '8px' } }}
        />
      )}
    />
  );
};

export default ControlledRadioBox;
